import { HelperService } from '../../../../../../src/app/services/helper/helper.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Component } from '@angular/core';

@Component({
  template: ''
})
export abstract class ControlBaseComponent {
  public isValidationError = false;
  constructor(public helperService: HelperService
  ) { }

}
